export class NotEnrolledVehicleError extends Error {
    constructor(m?: string) {
        if (!m) {
            m = 'Error due to disenrolling a vehicle which is not enrolled';
        }
        super(m);
    }
}